import { FC } from "react";

import { Box, Flex, NavLink, NavShopAllLink, ProductBadge, Text } from "@theme/components";
import { NavCategory, NavSubCategory } from "@theme/types";

interface NavProductListProps {
  navCategory: NavCategory;
  subCategory: NavSubCategory;
  closeNavigation: () => void;
}

export const NavProductList: FC<NavProductListProps> = ({
  navCategory,
  subCategory,
  closeNavigation,
}) => {
  return (
    <Box>
      <Flex
        as="ul"
        sx={{
          margin: 0,
          padding: 0,
          listStyle: "none",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: ["s400", null, null, "s500"],
          alignSelf: "stretch",
        }}
      >
        {subCategory.products.map((product, index) => {
          return (
            <Box as="li" key={index}>
              <NavLink
                variant="box"
                role="link"
                to={product?.pageSlug}
                sx={{
                  "&:hover": {
                    "& .subtitle": {
                      color: "grey700",
                    },
                  },
                }}
                onClick={closeNavigation}
              >
                {product.productBadge && <ProductBadge {...product.productBadge} />}

                <Text
                  className="title"
                  variant="sansBody02Regular"
                  sx={{
                    color: "grey700",
                    display: "block",
                  }}
                >
                  {product?.title}
                </Text>

                <Text
                  className="subtitle"
                  variant="sansBody01Regular"
                  sx={{
                    color: "grey500",
                    lineHeight: "lh300",
                    display: "block",
                  }}
                >
                  {product?.subtitle}
                </Text>
              </NavLink>
            </Box>
          );
        })}
      </Flex>
      {subCategory?.slug && (
        <NavShopAllLink
          to={`${navCategory.pageSlug}?subcategory=${subCategory.slug}`}
          onClick={closeNavigation}
          text={subCategory.shopAllText}
          ariaLabel={subCategory.shopAllText}
          sx={{ my: "s400" }}
        />
      )}
    </Box>
  );
};
